export default __webpack_public_path__ + "static/media/snooze-white.66803c61.svg";